import {store} from '@/libs'
import './main'
import './custom'
import './order'

export default store
